import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  HStack,
  Image,
  Box,
  useColorModeValue,
  Flex,
} from "@chakra-ui/react";
import { theme } from "src/styles/theme";
import AppDownload from "../../../assets/AppDownload.png";
import { MdOutlineArrowOutward } from "react-icons/md";
interface AppDownloadModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AppDownloadModal: React.FC<AppDownloadModalProps> = ({
  isOpen,
  onClose,
}) => {
  const bgColor = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue(theme.text, theme.text);

  const handleDownloadApp = () => {
    // Detectar se é Android ou iOS
    const isAndroid = /Android/i.test(navigator.userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isAndroid) {
      // Redirecionar para Google Play Store
      window.open(
        "https://play.google.com/store/apps/details?id=br.com.direcional.boravender&pcampaignid=web_share",
        "_blank"
      );
    } else if (isIOS) {
      // Redirecionar para App Store
      window.open(
        "https://apps.apple.com/br/app/bora-vender-grupo-direcional/id6449042919",
        "_blank"
      );
    } else {
      // Fallback para página de download
      window.open("https://boravender.app.br/login", "_blank");
    }

    // Marcar que o usuário já viu o modal
    localStorage.setItem("@app-download-modal-shown", "true");
    onClose();
  };

  const handleRemindLater = () => {
    // Marcar para mostrar novamente em 7 dias
    const remindDate = new Date();
    remindDate.setDate(remindDate.getDate() + 7);
    localStorage.setItem("@app-download-remind-date", remindDate.toISOString());
    onClose();
  };

  const handleDontShowAgain = () => {
    localStorage.setItem("@app-download-modal-dismissed", "true");
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay bg="blackAlpha.600" />
      <ModalContent bg={bgColor} mx={4}>
        <ModalCloseButton />

        <ModalBody>
          <VStack spacing={4} align="center">
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              mt={"20px"}
            >
              <Image
                src={AppDownload}
                alt="App Icon"
                boxSize="300px"
                borderRadius="16px"
              />
            </Box>

            <Text
              color={textColor}
              textAlign="center"
              fontSize="lg"
              fontWeight={"medium"}
            >
              Sua experiência fica melhor no app!
            </Text>

            <VStack spacing={2} align="center">
              <Text color={theme.text50} fontSize="sm" textAlign="center">
                O aplicativo do Bora Vender já está disponível no Google Play e
                App Store
              </Text>
            </VStack>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <VStack spacing={3} width="100%">
            <Button
              colorScheme="blue"
              size="lg"
              width="100%"
              onClick={handleDownloadApp}
              bg={theme.primary}
              _hover={{ bg: theme.primary }}
              fontWeight={"medium"}
            >
              <Flex
                align={"center"}
                justify={"center"}
                fontSize={"lg"}
                gap={"5px"}
              >
                Baixar aplicativo
                <Box fontSize={"22px"} w={"fit-content"}>
                  <MdOutlineArrowOutward />
                </Box>
              </Flex>
            </Button>

            <HStack spacing={4} width="100%">
              <Button
                variant="ghost"
                size="sm"
                onClick={handleRemindLater}
                color={textColor}
                flex={1}
              >
                Lembrar depois
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={handleDontShowAgain}
                color={textColor}
                flex={1}
              >
                Não mostrar novamente
              </Button>
            </HStack>
          </VStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AppDownloadModal;
